/**
 * CaseStatusPath — Visual status stepper for Credit Block cases.
 * Shows the status progression: New → In Progress → Resolved → Closed
 */
import React from 'react';

const STATUSES = ['New', 'In Progress', 'Resolved', 'Closed'] as const;

interface CaseStatusPathProps {
  currentStatus: string;
}

const CaseStatusPath: React.FC<CaseStatusPathProps> = ({ currentStatus }) => {
  const normalized = (currentStatus ?? '').trim();
  const currentIndex = STATUSES.findIndex(
    (s) => s.toLowerCase() === normalized.toLowerCase()
  );
  const activeIdx = currentIndex >= 0 ? currentIndex : -1;

  return (
    <div className="flex items-center gap-0 w-full">
      {STATUSES.map((status, idx) => {
        const isCompleted = idx < activeIdx;
        const isCurrent = idx === activeIdx;

        return (
          <React.Fragment key={status}>
            {idx > 0 && (
              <div
                className={`h-0.5 flex-1 transition-colors ${
                  isCompleted || isCurrent ? 'bg-blue-500' : 'bg-gray-300 dark:bg-gray-600'
                }`}
              />
            )}
            <div className="flex flex-col items-center min-w-[4rem]">
              <div
                className={`w-6 h-6 rounded-full flex items-center justify-center text-[10px] font-bold transition-colors ${
                  isCompleted
                    ? 'bg-blue-500 text-white'
                    : isCurrent
                    ? 'bg-blue-600 text-white ring-2 ring-blue-300 dark:ring-blue-700'
                    : 'bg-gray-200 dark:bg-gray-700 text-gray-500 dark:text-gray-400'
                }`}
              >
                {isCompleted ? '\u2713' : idx + 1}
              </div>
              <span
                className={`mt-1 text-[10px] leading-tight text-center ${
                  isCurrent
                    ? 'text-blue-700 dark:text-blue-300 font-semibold'
                    : isCompleted
                    ? 'text-blue-600 dark:text-blue-400'
                    : 'text-gray-500 dark:text-gray-400'
                }`}
              >
                {status}
              </span>
            </div>
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default CaseStatusPath;
